<template>
  <div id="app">
    <template  v-if="pageList.length > 0">
      <h3 class="c-heading__title3 p-detailPage__title3">{{labels.detail.title}}</h3>
      <ul class="p-detailPage__tileWrap">
        <li class="c-squareTile__item p-squareTile__item--detailPage" v-for="item in itemList" v-bind:key="item.id">
          <a
            v-bind:href="item.alias"
            v-bind:target="item.target ? '_blank' : false"
            class="c-squareTile__link p-squareTile__link"
            >
            <div class="c-squareTile__image p-squareTile__image">
              <img v-bind:src="item.image" />
            </div>
            <p class="c-squareTile__title p-squareTile__title"  v-html="item.title"></p>
            <span class="c-squareTile__date p-squareTile__date">{{item.date}}</span>
          </a>
        </li>
      </ul>
    </template>
  </div>
</template>

<script>
// // @ts-check
  import axios from "axios";

  const JSON_PATH = "/today/list.json";

  export default {
    name: "list",
    data: function () {
      return {
        pageList: [],
        labels: {
          "detail": {
            "title": "Latest"
          }
        },

        pageOffset: 0,
        pageSize: 4
      };
    },
    computed: {
      itemList: function () {
        return this.pageList.slice(this.pageOffset, this.pageSize);
      }
    },
    created: function () {
      // get data
      axios.get(JSON_PATH).then(response => {
        this.pageList = response.data.page_list;
        this.labels = response.data.labels;
      });
    }
  };
</script>
